/* eslint-disable max-len  */
/* eslint-disable no-template-curly-in-string */
export default {
    apps: {
        admin: 'Administration',
        locator: 'Find & Locate',
        setup: 'Scan Device',
    },
}
